import "./TechnicalInspection.module.css";
import Header from "@/reusable_sections/Header";
import Sopralluogo from "./sections/Sopralluogo";
import Location from "./sections/Location";
import Footer from "@/reusable_sections/Footer";
export default function TechnicalInspectionPage() {
  return <div>
      <Header />
      <Sopralluogo />
      <Location />
      <Footer />
    </div>;
}